module.exports = __webpack_public_path__ + "static/img/qrcode_bottom.888d615.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode_bottom.jpg
// module id = Wa7x
// module chunks = 2